import React, { useState } from 'react';
import { ChevronRight, Mail, Phone, Edit, CheckCircle, Star, Clock, ThumbsUp, Calendar, ChevronDown, Briefcase, UserX, ArrowLeft, MapPin, FileText, Plus } from 'lucide-react';
interface TeamMemberProfileProps {
  onBack: () => void;
}
export function TeamMemberProfile({
  onBack
}: TeamMemberProfileProps) {
  const [isHistoryExpanded, setIsHistoryExpanded] = useState(false);
  // Mock data for Lucia Martini
  const member = {
    name: 'Lucia Martini',
    initials: 'LM',
    role: 'Operatore sul Campo',
    status: 'available',
    email: 'lucia.martini@cleanlogistics.it',
    phone: '+39 345 678 9012',
    avatarColor: 'bg-pink-100 text-pink-700',
    stats: {
      completed: 47,
      rating: 4.8,
      punctuality: '98%',
      acceptance: '92%'
    }
  };
  const upcomingJobs = [{
    id: 1,
    date: 'Oggi, 14:30',
    address: 'Via Roma 4',
    package: 'Pacchetto Zona Prati',
    status: 'Confermato'
  }, {
    id: 2,
    date: 'Domani, 09:00',
    address: 'Via Milano 12',
    package: 'Pacchetto Centro',
    status: 'Confermato'
  }];
  const pastJobs = [{
    id: 101,
    date: '05 Feb 2026',
    property: 'Via Napoli 8',
    duration: '2h 15m',
    rating: 5
  }, {
    id: 102,
    date: '04 Feb 2026',
    property: 'Corso Italia 22',
    duration: '1h 45m',
    rating: 4
  }, {
    id: 103,
    date: '02 Feb 2026',
    property: 'Piazza Dante 5',
    duration: '3h 00m',
    rating: 5
  }, {
    id: 104,
    date: '30 Gen 2026',
    property: 'Via Verdi 10',
    duration: '2h 30m',
    rating: 5
  }];
  return <div className="space-y-6" data-id="element-2328">
      {/* Header Section */}
      <div className="flex flex-col gap-6" data-id="element-2329">
        <nav className="flex items-center gap-2 text-xs text-gray-500" data-id="element-2330">
          <button onClick={onBack} className="hover:text-teal-deep transition-colors" data-id="element-2331">
            Il Mio Team
          </button>
          <ChevronRight size={12} data-id="element-2332" />
          <span className="text-navy font-medium" data-id="element-2333">{member.name}</span>
        </nav>

        <div className="bg-white border border-gray-200 rounded-xl p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-2334">
          <div className="flex items-center gap-5" data-id="element-2335">
            <div className={`w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold ${member.avatarColor}`} data-id="element-2336">
              {member.initials}
            </div>
            <div data-id="element-2337">
              <div className="flex items-center gap-3 mb-1" data-id="element-2338">
                <h1 className="text-2xl font-bold font-montserrat text-navy" data-id="element-2339">
                  {member.name}
                </h1>
                <span className="bg-green-100 text-green-800 rounded-full text-xs font-medium px-2 py-0.5" data-id="element-2340">
                  Disponibile
                </span>
              </div>
              <p className="text-gray-500 text-sm mb-3" data-id="element-2341">{member.role}</p>
              <div className="flex flex-wrap gap-4 text-sm text-gray-600" data-id="element-2342">
                <div className="flex items-center gap-2" data-id="element-2343">
                  <Mail size={14} className="text-gray-400" data-id="element-2344" />
                  <span data-id="element-2345">{member.email}</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-2346">
                  <Phone size={14} className="text-gray-400" data-id="element-2347" />
                  <span data-id="element-2348">{member.phone}</span>
                </div>
              </div>
            </div>
          </div>
          <button className="p-2 border border-gray-200 rounded-lg hover:bg-gray-50 text-gray-500 transition-colors self-start md:self-center" data-id="element-2349">
            <Edit size={18} data-id="element-2350" />
          </button>
        </div>
      </div>

      {/* Performance Summary Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2351">
        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-2352">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-2353">
            Lavori Completati
          </div>
          <div className="flex items-center gap-2" data-id="element-2354">
            <CheckCircle className="text-teal-deep w-5 h-5" data-id="element-2355" />
            <span className="text-2xl font-bold text-navy" data-id="element-2356">
              {member.stats.completed}
            </span>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-2357">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-2358">
            Valutazione Media
          </div>
          <div className="flex items-center gap-2" data-id="element-2359">
            <Star className="text-amber-500 w-5 h-5 fill-current" data-id="element-2360" />
            <span className="text-2xl font-bold text-navy" data-id="element-2361">
              {member.stats.rating}
              <span className="text-sm text-gray-400 font-normal" data-id="element-2362">/5</span>
            </span>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-2363">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-2364">
            Puntualità
          </div>
          <div className="flex items-center gap-2" data-id="element-2365">
            <Clock className="text-blue-500 w-5 h-5" data-id="element-2366" />
            <span className="text-2xl font-bold text-navy" data-id="element-2367">
              {member.stats.punctuality}
            </span>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-2368">
          <div className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-2369">
            Tasso Accettazione
          </div>
          <div className="flex items-center gap-2" data-id="element-2370">
            <ThumbsUp className="text-purple-500 w-5 h-5" data-id="element-2371" />
            <span className="text-2xl font-bold text-navy" data-id="element-2372">
              {member.stats.acceptance}
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2373">
        {/* Left Column: Calendar & Availability */}
        <div className="lg:col-span-2 space-y-6" data-id="element-2374">
          {/* Availability Calendar */}
          <div className="bg-white border border-gray-200 rounded-xl p-6" data-id="element-2375">
            <div className="flex justify-between items-center mb-6" data-id="element-2376">
              <h3 className="font-semibold text-navy flex items-center gap-2" data-id="element-2377">
                <Calendar size={18} className="text-teal-deep" data-id="element-2378" />
                Disponibilità Settimanale
              </h3>
              <button className="text-xs font-medium text-teal-deep hover:underline" data-id="element-2379">
                Modifica Disponibilità
              </button>
            </div>

            {/* Mock Weekly Calendar Grid */}
            <div className="grid grid-cols-7 gap-2 mb-4 text-center" data-id="element-2380">
              {['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'].map(day => <div key={day} className="text-xs font-medium text-gray-500 uppercase" data-id="element-2381">
                  {day}
                </div>)}
              {/* Row 1: Morning */}
              {[1, 1, 1, 1, 1, 0, 0].map((status, i) => <div key={`m-${i}`} className={`h-12 rounded-md border ${status ? 'bg-green-50 border-green-100' : 'bg-gray-50 border-gray-100'} flex items-center justify-center text-[10px] text-gray-400`} data-id="element-2382">
                  Mattina
                </div>)}
              {/* Row 2: Afternoon */}
              {[1, 1, 0, 1, 1, 1, 0].map((status, i) => <div key={`a-${i}`} className={`h-12 rounded-md border ${status ? 'bg-green-50 border-green-100' : 'bg-gray-50 border-gray-100'} flex items-center justify-center text-[10px] text-gray-400`} data-id="element-2383">
                  Pom.
                </div>)}
            </div>

            <div className="flex gap-4 justify-center text-xs text-gray-500" data-id="element-2384">
              <div className="flex items-center gap-1.5" data-id="element-2385">
                <div className="w-3 h-3 bg-green-50 border border-green-100 rounded" data-id="element-2386"></div>
                <span data-id="element-2387">Disponibile</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-2388">
                <div className="w-3 h-3 bg-blue-50 border border-blue-100 rounded" data-id="element-2389"></div>
                <span data-id="element-2390">Occupato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-2391">
                <div className="w-3 h-3 bg-gray-50 border border-gray-100 rounded" data-id="element-2392"></div>
                <span data-id="element-2393">Non Disponibile</span>
              </div>
            </div>
          </div>

          {/* Job History */}
          <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-2394">
            <button onClick={() => setIsHistoryExpanded(!isHistoryExpanded)} className="w-full p-4 flex justify-between items-center hover:bg-gray-50 transition-colors" data-id="element-2395">
              <h3 className="font-semibold text-navy text-sm" data-id="element-2396">
                Storico Lavori
              </h3>
              <ChevronDown size={16} className={`text-gray-400 transition-transform ${isHistoryExpanded ? 'rotate-180' : ''}`} data-id="element-2397" />
            </button>

            {isHistoryExpanded && <div className="border-t border-gray-200" data-id="element-2398">
                <table className="w-full text-sm text-left" data-id="element-2399">
                  <thead className="bg-gray-50 text-gray-500 font-medium border-b border-gray-200" data-id="element-2400">
                    <tr data-id="element-2401">
                      <th className="px-4 py-3 font-medium" data-id="element-2402">Data</th>
                      <th className="px-4 py-3 font-medium" data-id="element-2403">Proprietà</th>
                      <th className="px-4 py-3 font-medium" data-id="element-2404">Durata</th>
                      <th className="px-4 py-3 font-medium" data-id="element-2405">Valutazione</th>
                      <th className="px-4 py-3 font-medium text-right" data-id="element-2406">
                        Azioni
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100" data-id="element-2407">
                    {pastJobs.map(job => <tr key={job.id} className="hover:bg-gray-50" data-id="element-2408">
                        <td className="px-4 py-3 text-gray-600" data-id="element-2409">{job.date}</td>
                        <td className="px-4 py-3 font-medium text-navy" data-id="element-2410">
                          {job.property}
                        </td>
                        <td className="px-4 py-3 text-gray-600" data-id="element-2411">
                          {job.duration}
                        </td>
                        <td className="px-4 py-3" data-id="element-2412">
                          <div className="flex items-center gap-1 text-amber-500" data-id="element-2413">
                            <span className="font-bold text-navy" data-id="element-2414">
                              {job.rating}
                            </span>
                            <Star size={12} fill="currentColor" data-id="element-2415" />
                          </div>
                        </td>
                        <td className="px-4 py-3 text-right" data-id="element-2416">
                          <button className="text-teal-deep hover:underline text-xs font-medium" data-id="element-2417">
                            Report
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
                <div className="p-3 border-t border-gray-200 text-center" data-id="element-2418">
                  <button className="text-xs text-gray-500 hover:text-navy font-medium" data-id="element-2419">
                    Carica altri...
                  </button>
                </div>
              </div>}
          </div>
        </div>

        {/* Right Column: Upcoming & Actions */}
        <div className="space-y-6" data-id="element-2420">
          {/* Upcoming Jobs */}
          <div className="bg-white border border-gray-200 rounded-xl p-5" data-id="element-2421">
            <h3 className="font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-2422">
              <Briefcase size={18} className="text-teal-deep" data-id="element-2423" />
              Lavori Assegnati
            </h3>
            <div className="space-y-3" data-id="element-2424">
              {upcomingJobs.map(job => <div key={job.id} className="border border-gray-100 rounded-lg p-3 hover:border-teal-deep/30 transition-colors bg-gray-50/50" data-id="element-2425">
                  <div className="flex justify-between items-start mb-2" data-id="element-2426">
                    <span className="text-xs font-medium text-teal-deep bg-teal-50 px-2 py-0.5 rounded-full" data-id="element-2427">
                      {job.date}
                    </span>
                    <span className="text-[10px] text-green-600 font-bold uppercase tracking-wider" data-id="element-2428">
                      {job.status}
                    </span>
                  </div>
                  <h4 className="font-bold text-navy text-sm mb-1" data-id="element-2429">
                    {job.address}
                  </h4>
                  <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-2430">
                    <Package size={12} data-id="element-2431" />
                    {job.package}
                  </p>
                </div>)}
            </div>
          </div>

          {/* Actions Section */}
          <div className="bg-white border border-gray-200 rounded-xl p-5" data-id="element-2432">
            <h3 className="font-semibold text-navy mb-4" data-id="element-2433">Azioni Rapide</h3>
            <div className="space-y-3" data-id="element-2434">
              <button className="w-full bg-teal-deep text-white rounded-lg hover:bg-teal-deep/90 font-medium text-sm py-2.5 flex items-center justify-center gap-2 shadow-sm transition-colors" data-id="element-2435">
                <Plus size={16} data-id="element-2436" />
                Assegna Nuovo Lavoro
              </button>
              <button className="w-full border border-gray-200 text-navy rounded-lg hover:bg-gray-50 font-medium text-sm py-2.5 flex items-center justify-center gap-2 transition-colors" data-id="element-2437">
                <FileText size={16} data-id="element-2438" />
                Modifica Profilo
              </button>
              <button className="w-full text-red-600 hover:bg-red-50 rounded-lg font-medium text-sm py-2.5 flex items-center justify-center gap-2 transition-colors" data-id="element-2439">
                <UserX size={16} data-id="element-2440" />
                Disattiva Collaboratore
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
// Helper icon component since Package is used in JSX but not imported in the mock data section
function Package({
  size,
  className
}: {
  size?: number;
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size || 24} height={size || 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-2441">
      <path d="m7.5 4.27 9 5.15" data-id="element-2442" />
      <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" data-id="element-2443" />
      <path d="m3.3 7 8.7 5 8.7-5" data-id="element-2444" />
      <path d="M12 22v-9" data-id="element-2445" />
    </svg>;
}